import { Konva } from './_FullInternals.js';
export default Konva;
//# sourceMappingURL=index.js.map